import type { ReactNode } from 'react';

/** Inline warning when not all survey questions on the page are answered. */
export default function SurveyValidationAlert({ children }: { children: ReactNode }) {
  return (
    <p
      role="alert"
      className="max-w-[min(100%,20rem)] text-center text-sm font-medium leading-snug text-amber-100 drop-shadow-[0_1px_8px_rgba(0,0,0,0.55)]"
    >
      {children}
    </p>
  );
}
